import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=45481a82"
import script from "./activate.vue?vue&type=script&lang=js"
export * from "./activate.vue?vue&type=script&lang=js"
import style0 from "./activate.vue?vue&type=style&index=0&id=45481a82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports